module.exports = "https://static.wmbcdn.com/uniweb/images/5c622ea8ec0b964ee1b4c9d79a618401.svg";